<div class="w-full flex flex-col gap-1">
  @if (!isLoading) {
    <palantir-card (mouseover)="isHovering.set(true)" (mouseout)="isHovering.set(false)">
      <div
        palantir-card-content
        class="border-color-neutral-surface border border-solid rounded-lg"
        [ngClass]="{
          'hover-border-bg': isHovering(),
        }"
      >
        <div class="flex justify-between items-center mb-2">
          <palantir-text type="title"> {{ warranty.name }}</palantir-text>
          @if (warranty.status) {
            <app-warranty-status-label [status]="warranty.status" [isHovering]="isHovering()"></app-warranty-status-label>
          }
        </div>
        <div style="width: 100%; overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap">
          <palantir-text type="subtitle"> {{ 'ASSETS_TREE.DETAILS_SECTION.WARRANTIES.START' | translate }} </palantir-text>
          <palantir-text type="title"> {{ warranty.startDate | date: 'dd/MM/yyyy' }} </palantir-text>
        </div>
        <div style="width: 100%; overflow: hidden; text-overflow: ellipsis; text-wrap: nowrap">
          <palantir-text type="subtitle"> {{ 'ASSETS_TREE.DETAILS_SECTION.WARRANTIES.END' | translate }} </palantir-text>
          <palantir-text type="title"> {{ warranty.endDate | date: 'dd/MM/yyyy' }} </palantir-text>
        </div>
      </div>
    </palantir-card>
  }
  @if (isLoading) {
    <palantir-skeleton class="w-full h-8 rounded-lg"></palantir-skeleton>
  }
</div>
